type MediaQueryListLike = {
  matches: boolean;
  media: string;
  onchange: null;
  addEventListener: () => void;
  removeEventListener: () => void;
  addListener: () => void;
  removeListener: () => void;
  dispatchEvent: () => boolean;
};

function createMediaQueryList(query: string): MediaQueryListLike {
  return {
    matches: false,
    media: query,
    onchange: null,
    addEventListener: () => undefined,
    removeEventListener: () => undefined,
    addListener: () => undefined,
    removeListener: () => undefined,
    dispatchEvent: () => false,
  };
}

export function ensureMatchMedia() {
  if (typeof window === 'undefined') {
    return;
  }

  if (typeof window.matchMedia === 'function') {
    return;
  }

  window.matchMedia = (query: string) => createMediaQueryList(query) as any;
}
